import { render, staticRenderFns } from "./AvatarDetails.vue?vue&type=template&id=5bc37fb0"
import script from "./AvatarDetails.vue?vue&type=script&lang=js"
export * from "./AvatarDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports